<template>
    <div class="TemplateTab p-3">
        <div class="SearchArea">
            <input type="search" @input="onChange($event)" :value="selectedValue"
                class="form-control rounded-pill h-45px" placeholder="Search ... " />
        </div>
        <div class="imagsGallery">
            <h5 class="text-muted py-2">Giphy</h5>
            <!-- <div class="wrapperDiv addpositionRelative" v-if="isImagesLoading === true">
                <div class="imageLoader ">
                 <LoaderSpinner></LoaderSpinner>
                </div> 
            </div> -->
            <!-- <div @scroll="handleScroll" :class="`showImgs containerimg  ${isImagesLoading === true ? 'hidevisibility' : ''}`" id="masonry-grid"> -->
            <div @scroll="handleScroll" :class="`showImgs containerimg  `" id="masonry-grid">
                <div class="grid-sizer"></div>
                <a :draggable="true" @dragstart="dragElement($event, item.images.original.url)" href="javascript:;"
                    @click="addgifinCanvas(item.images.original.url)" class="column" v-for="(item, index) of gifList"
                    v-bind:key="index">
                    <img @load="handleLoad" class="" :width="`${item.images.preview_gif.width}`"
                        :height="`${item.images.preview_gif.height}`" ref="img" :src="`${item.images.preview_gif.url}`"
                        alt="" />

                </a>
                <!-- <a :draggable="true" @dragstart="dragElement($event,'/testgif.gif')" href="javascript:;" @click="addVideoinCanvas('https://player.vimeo.com/external/289258217.hd.mp4?s=5cf87d7670d96bbd2c110f4dc97fd5116f4468ad&amp;profile_id=170&amp;oauth2_token_id=57447761')" class="column">

                    <img class="img-fluid mt-3" ref="img" src="https://images.pexels.com/videos/1409899/pictures/preview-0.jpg" alt="" />
                </a> -->
            </div>
        </div>
    </div>
</template>
<script>

import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
// import Masonry from "masonry-layout";
// import LoaderSpinner from "../../utils/TabLoader.vue";
import { debounce } from "lodash";


export default {
    name: "GiphyTab",
    data() {
        return {
            gifList: [],
            APIKEY: "Rvr5bOfefnd3EJWJ6nZb9Q5rq1L5wrG0",
            isImagesLoading: true,
            selectedValue: '',
            randomOffset: 0,
            searchrandomOffset: 0,
            imageLoadCount: 0,
            debouncedSearch: debounce(this.searchData, 500),
        }
    },
    components: {
        // LoaderSpinner
    },
    mounted() {
        // this.DND();
        this.GetRandomGifs();
        //http://api.giphy.com/v1/gifs/search?q=ryan+gosling&api_key=Rvr5bOfefnd3EJWJ6nZb9Q5rq1L5wrG0
    },
    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
    },
    methods: {
        handleLoad() {
            this.imageLoadCount++;
            // if(this.imageLoadCount === this.gifList.length) {
            //     this.initmasnory();
            // }
        },
        onChange(e) {
            let value = e.target.value;
            this.selectedValue = value;
            if (value === '') {
                this.gifList = [];
                this.searchrandomOffset = 50
            }
            this.debouncedSearch(value);
        },
        searchData(query) {
            console.log(query)
            if (query === "") {
                this.GetRandomGifs();
            } else {

                this.searchGetRandomGifs(query)
            }
        },

        handleScroll() {
            const container = this.$el.querySelector("#masonry-grid");
            const scrollPosition = container.scrollTop + container.clientHeight;
            const totalHeight = container.scrollHeight;

            // Adjust the threshold as needed
            if (scrollPosition >= totalHeight - 200) {
                // Fetch more images when the user is near the bottom
                if (this.selectedValue === '') {
                    this.GetRandomGifs();
                } else {
                    this.searchGetRandomGifs(this.selectedValue)
                }
            }
        },
        //     initmasnory(){
        //     var grid = document.querySelector('#masonry-grid');
        //     new Masonry(grid, {
        //         // options...
        //         columnWidth: '.grid-sizer',
        //         itemSelector: '.column',
        //         percentPosition: true,
        //         gutter: 10
        //     });
        //     this.isImagesLoading = false;

        //    },
        searchGetRandomGifs(query) {

            // this.isImagesLoading = true;
            this.searchrandomOffset = this.searchrandomOffset + 50;

            var GIFURL = "http://api.giphy.com/v1/gifs/search?api_key=" + this.APIKEY + "&limit=50&offset=" + this.searchrandomOffset + '&q=' + query;

            let self = this;
            axios({
                method: 'get',
                url: GIFURL,
            })
                .then(function (response) {
                    console.log(self.searchrandomOffset)
                    // if(self.searchrandomOffset === 50){
                    self.gifList = [...response.data.data];
                    // } else {
                    //     self.gifList = [...self.gifList,...response.data.data];
                    // }

                    console.log(response)
                    // self.$nextTick(function () {
                    // //    setTimeout(() => {
                    //      self.initmasnory();
                    // //    }, 1500);

                    // })
                });

        },
        GetRandomGifs() {
            // this.isImagesLoading = true;
            this.randomOffset = this.randomOffset + 50;

            var GIFURL = "http://api.giphy.com/v1/gifs/trending?api_key=" + this.APIKEY + "&limit=50&offset=" + this.randomOffset;

            let self = this;
            axios({
                method: 'get',
                url: GIFURL,
            })
                .then(function (response) {
                    let newlist = [...self.gifList, ...response.data.data];
                    self.gifList = newlist;
                    // self.gifList = response.data.data;
                    console.log(response)
                    // self.$nextTick(function () {
                    // //    setTimeout(() => {
                    //      self.initmasnory();
                    // //    }, 1500);

                    // })
                });

        },
        addgifinCanvas(url) {


            this.$store.dispatch("addObjectInCanvas",
                {
                    id: `gif_${uuidv4()}`,
                    type: 'img',
                    rotate: 0,
                    // top:200,
                    // left:100,
                    top: 0,
                    left: 0,
                    scaleX: 1,
                    scaleY: 1,
                    zoom: 1,
                    // width:150,
                    width: this.getActiveCanvas.size.width,
                    // height:100,
                    height: this.getActiveCanvas.size.height,
                    opacity: 1,
                    lock: false,
                    borderRadius: 0,
                    url: url,
                    brightness: 100,
                    contrast: 100,
                    saturation: 100,
                    isInAnimationActive: false,
                    isOutAnimationActive: false,
                    isLoopAnimationActive: false,
                    AnimationSequence: [],
                    animationClassIn: "",
                    animationClassOut: "",
                    animationClass: "",
                    animationClassLoop: "",
                    animationDelay: 0,
                    animationDuration: 2,
                    animationDelayIn: 0,
                    animationDurationIn: 2,
                    animationDelayOut: 0,
                    animationDurationOut: 2,
                    animationLoopDuration: 2,
                    orientation: 0,
                    adjustment: 'cover',
                    animationLoop: false
                },
            )
        },

        dragElement(e, link) {

            let obj = {
                id: `gif_${uuidv4()}`,
                type: 'img',
                // top:200,
                // left:100,
                rotate: 0,
                top: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1,
                zoom: 1,
                width: this.getActiveCanvas.size.width,
                height: this.getActiveCanvas.size.height,
                opacity: 1,
                lock: false,
                borderRadius: 0,
                url: link,
                brightness: 100,
                contrast: 100,
                saturation: 100,
                animationClassIn: "",
                animationClassOut: "",
                animationClass: "",
                animationClassLoop: "",
                animationDelay: 0,
                animationDuration: 2,
                animationDelayIn: 0,
                animationDurationIn: 2,
                animationDelayOut: 0,
                animationDurationOut: 2,
                animationLoopDuration: 2,
                orientation: 0,
                adjustment: 'cover',
                animationLoop: false
            };
            var j = JSON.stringify(obj);
            e.dataTransfer.setData("imgs", j);
        },


    },

}
</script>

<!-- <style scoped>
.h-45px {
    height: 45px;
}

.imagsGallery h5 {
    letter-spacing: .1em;
    font-size: 15px;

}

.containerimg {
    height: 95vh;
    overflow-y: scroll;
}

#flexbox {
    display: flex;
    flex-wrap: wrap;
    padding: 0 4px;
}

.column {
    flex: 50%;
    max-width: 50%;
    padding: 0 4px;
}

.column img {
    vertical-align: middle;
    margin-top: 8px;
    width: 100%;

}

.column:nth-child(even) {
    display: flex;
    flex-direction: column-reverse;
}
</style> -->

<style scoped>
/* .containerimg {
  display: flex;
  flex-wrap: wrap;
} */
.h-45px {
    height: 45px;
}

.imagsGallery h5 {
    letter-spacing: .1em;
    font-size: 15px;

}

.containerimg {
    /* height: 95vh !important; */
    height: calc(100vh - 258px) !important;
    overflow-y: scroll;
}

.column {
    display: block;
    width: 100%;
    /* Adjust as needed */
    box-sizing: border-box;
    padding: 5px;
    /* Adjust as needed */
}

.grid-sizer {
    width: 50%;
}

.column img {
    width: 100%;
    height: auto;
    border-radius: 5px;
}

.addPositionAbsolute {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.addpositionRelative {
    position: relative;
    height: 100vh;
}

.imageLoader {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.imagsGallery {
    position: relative;
}

.hidevisibility {
    visibility: hidden;
    position: fixed;
    top: 0;
}
</style>